import * as React from 'react';

function SvgSelectTenancy(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6.15 6.01h17v15h-17v-15z" fill="#FCCE01" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.35.01c.47 0 .85.38.85.85v1.3H19a4.85 4.85 0 014.85 4.85v12A4.85 4.85 0 0119 23.86H5a4.85 4.85 0 01-4.85-4.85v-1a.85.85 0 011.7 0v1A3.15 3.15 0 005 22.16h14a3.15 3.15 0 003.15-3.15V9.527H1.85v4.594a.85.85 0 11-1.7 0V7.01A4.85 4.85 0 015 2.16h1.8V.86a.85.85 0 011.7 0v1.3h7V.86c0-.47.38-.85.85-.85zM6.8 3.86v1.3a.85.85 0 001.7 0v-1.3h7v1.3a.85.85 0 001.7 0v-1.3H19a3.15 3.15 0 013.15 3.15v.817H1.85V7.01A3.15 3.15 0 015 3.86h1.8zM4 12.21c0-.11.09-.2.2-.2h2.6c.11 0 .2.09.2.2v1.6a.2.2 0 01-.2.2H4.2a.2.2 0 01-.2-.2v-1.6zm8.2 5.8a.2.2 0 00-.2.2v1.6c0 .11.09.2.2.2h2.6a.2.2 0 00.2-.2v-1.6a.2.2 0 00-.2-.2h-2.6zM9 12.21c0-.11.09-.2.2-.2h2.6c.11 0 .2.09.2.2v1.6a.2.2 0 01-.2.2H9.2a.2.2 0 01-.2-.2v-1.6zm8.2 5.8a.2.2 0 00-.2.2v1.6c0 .11.09.2.2.2h2.6a.2.2 0 00.2-.2v-1.6a.2.2 0 00-.2-.2h-2.6z"
        fill="#595959"
      />
    </svg>
  );
}

export default SvgSelectTenancy;
